import { Add } from "@mui/icons-material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CommonButton from "../../common/button/Button";


interface CreateButtonProps {
    disable?: boolean;
    path?: string | undefined;
    label?: string | undefined;
}

const CreateButton: React.FC<CreateButtonProps> = ({ label, path }) => {
    const { t } = useTranslation();
    label = label || t("createTicket");
    path = path || "/admin/createTicket";
    return (
        <CommonButton
            {...{ component: Link, to: path }}
            variant='contained'
            color='primary'
            sx={{width:"15%", height:"30px"}}
            endIcon={<Add />}
        >
            {label}
        </CommonButton>
    );
};

export default CreateButton;
